module.exports = __webpack_public_path__ + "static/img/technologys.ccff75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/technologys.png
// module id = 1042
// module chunks = 1